module.exports = __webpack_public_path__ + "static/media/fps-36@2x.acc77556.png";